export default "/assets/images/peacekeeper-icon.4430d8b23e2a621b.png";